// @mui
import { Box, Container } from '@mui/material';
// components
import Image from '../../components/Image';
import { MotionViewport } from '../../components/animate';

// ----------------------------------------------------------------------

export default function AboutVision() {
  return (
    <Container component={MotionViewport} sx={{ mt: 2 }}>
      <Box
        sx={{
          mb: 2,
          position: 'relative',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        <Image
          src="/team/team.jpg"
          alt="about-vision"
          effect="black-and-white"
        />
        <Box
          sx={{
            bottom: { xs: 24, md: 80 },
            width: '100%',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            position: 'absolute',
            justifyContent: 'center',
          }}
        />
      </Box>
    </Container>
  );
}
